// import styled from "styled-components"
// import { useDispatch } from "react-redux"
// import { useSelector } from "react-redux";
// import { useEffect, useState } from "react";
// import { getBlogDetail, getBlogs, setSelectedBlog } from "../../features/admin3/admin3Slice";
// import create from "../../images/svg/create-chat.svg"
// import cn from "classnames";

// const Container = styled.div`
//     width: 330px;
//     max-height: 90vh;
//     min-height: auto;
//     overflow-y: auto;
//     overflow-x: hidden;
//     display: flex;
//     flex-direction: column;
//     color: ${({theme}) => theme.mainTextColor};
//     margin-right: 20px;

//     .message-kamyoon{
//         background: var(--color-main);
//         width: 100%;
//         height: 45px;
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         border-radius: 8px;
//         border-bottom-left-radius: 0;
//         border-bottom-right-radius: 0;
//         position: relative;
//         padding-inline: 20px;
//         img{
//             width: 20px;
//             cursor: pointer;
//         }
//         p{
//             font-size: var(--font-size-md);
//             font-weight: var(--font-weight-xl);
//             color: #fff;
//             display: flex;
//             align-items: center;
//             gap: 5px;
//         }
        
//     }

//     .titles-list{
//         display: flex;
//         flex-direction: column;
//         border: 1px solid ${({theme}) => theme.mainBorderColor};
//         border-top: none;
//         border-bottom-left-radius: 8px;
//         border-bottom-right-radius: 8px;
//         max-height: 65vh;
//         overflow-y: auto;
//         &::-webkit-scrollbar {
//             height: 8px;
//             width: 5px;
//         }
//         &::-webkit-scrollbar-thumb {
//             background-color: ${({theme})=> theme.secondaryTextColor};
//         }
//         &::-webkit-scrollbar-track {
//             background-color: transparent;
//         }

//         .blog-item{
//             border-bottom: 2px solid ${({theme}) => theme.mainBorderColor};
//             padding-block: 20px;
//             cursor: pointer;
//             display: flex;
//             flex-direction: column;
//             gap: 7px;
//             position: relative;
//             p{
//                 font-size: var(--font-size-sm);
//                 font-weight: var(--font-weight-lg);
//                 padding: 0 20px;
//             }
//         }
//         .blog-item:last-child{
//             border-bottom: none !important;
//         }
//     }
//     .selected-item{
//         background-color: ${({theme})=> theme.secondaryBgColor};
//     }
// `

// const BlogTabSide = () => {
//     const dispatch = useDispatch()
//     const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
//     const {webBlogList, selectedBlog} = useSelector((state) => state.admin3)

//     useEffect(() => {
//         dispatch(getBlogs())
//     }, [])
    
//     return (
//     <Container>
//         <div className="message-kamyoon">
//             <p>Bloglar</p>
//             <img onClick={() => dispatch(setSelectedBlog(null))} src={create} alt="" />
//         </div>
//         <div className="titles-list">
//             {webBlogList.map((blog) => (
//                 <div onClick={() => dispatch(getBlogDetail(blog?.slug))} className={cn("blog-item", selectedBlog?.id === blog?.id ? "selected-item" : "")}>
//                     <p>{blog.metaTitle}</p>
//                 </div>
//             ))}
//         </div>
//     </Container>
//   )
// }

// export default BlogTabSide

import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  getBlogDetail,
  getBlogs,
  setSelectedBlog,
  setSelectedBlogs,
} from "../../features/admin3/admin3Slice";
import create from "../../images/svg/create-chat.svg";
import cn from "classnames";
import { showModal } from "../../features/modal/modalSlice";
import Btn from "../shared/button/Btn";

const Container = styled.div`
  width: 330px;
  max-height: 90vh;
  min-height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.mainTextColor};
  margin-right: 20px;

  .message-kamyoon {
    background: var(--color-main);
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    position: relative;
    padding-inline: 20px;

    .header-actions {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    button {
      border: none;
      outline: none;
      background-color: #fff;
      color: var(--color-main);
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
      border-radius: 6px;
      padding: 5px 10px;
      cursor: pointer;
    }

    img {
      width: 20px;
      cursor: pointer;
    }

    p {
      font-size: var(--font-size-md);
      font-weight: var(--font-weight-xl);
      color: #fff;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  .titles-list {
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme.mainBorderColor};
    border-top: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    max-height: 65vh;
    overflow-y: auto;

    &::-webkit-scrollbar {
      height: 8px;
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.secondaryTextColor};
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    .blog-item {
      border-bottom: 2px solid ${({ theme }) => theme.mainBorderColor};
      padding-block: 20px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      gap: 7px;
      position: relative;

      .blog-item-content {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 0 20px;
      }

      input {
        width: 16px;
        height: 16px;
        cursor: pointer;
        accent-color: var(--color-main);
      }

      p {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        padding: 0;
        margin: 0;
      }
    }

    .blog-item:last-child {
      border-bottom: none !important;
    }
  }

  .selected-item {
    background-color: ${({ theme }) => theme.secondaryBgColor};
  }

  .multi-selected-item {
  }
`;

const BlogTabSide = () => {
  const dispatch = useDispatch();

    //! selectedBlog (eski update için kullanılıyor)
  //! selectedBlogs (yeni çoklu seçim/silme için kullanılıyor)
  const { webBlogList, selectedBlog, selectedBlogs } = useSelector((state) => state.admin3);

  const [selectMode, setSelectMode] = useState(false);

  useEffect(() => {
    dispatch(getBlogs());
  }, [dispatch]);

  const handleToggleSelectMode = () => {
    setSelectMode((prev) => {
      const nextMode = !prev;

      if (!nextMode) {
        dispatch(setSelectedBlogs([]));
      }

      return nextMode;
    });
  };

  const handleSelectBlog = (blog) => {
    const isSelected = selectedBlogs?.some((item) => item?.id === blog?.id);

    const nextSelectedBlogs = isSelected
      ? selectedBlogs.filter((item) => item?.id !== blog?.id)
      : [...selectedBlogs, blog];

    dispatch(setSelectedBlogs(nextSelectedBlogs));
  };

  const handleBlogClick = (blog) => {
    if (selectMode) {
      handleSelectBlog(blog);
    }

    dispatch(getBlogDetail(blog?.slug));
  };

  return (
    <Container>
            {
            (selectedBlogs.length > 0 && selectMode) && 
            <div style={{marginBottom: "20px"}}>
                <Btn width={"140px"} color="#E85446" bgColor="transparent" padding="0 10px"handleClick={() => {dispatch(setSelectedBlogs(selectedBlogs)); dispatch(showModal("adminDeleteMultiBlogPermission"))}}>Seçili Blogları Sil</Btn>
            </div>
        }
      <div className="message-kamyoon">
        <p>Bloglar</p>

        <div className="header-actions">
          <button type="button" onClick={handleToggleSelectMode}>
            {selectMode ? "Vazgeç" : "Seç"}
          </button>

          <img
            onClick={() => dispatch(setSelectedBlog(null))}
            src={create}
            alt=""
          />
        </div>
      </div>

      <div className="titles-list">
        {webBlogList.map((blog) => {
          const isMultiSelected = selectedBlogs?.some(
            (item) => item?.id === blog?.id
          );

          return (
            <div
              key={blog?.id}
              onClick={() => handleBlogClick(blog)}
className={cn("blog-item", {
  "selected-item": selectedBlog?.id === blog?.id,
})}
            >
              <div className="blog-item-content">
                {selectMode && (
                  <input
                    type="checkbox"
                    checked={isMultiSelected}
                    onChange={() => handleSelectBlog(blog)}
                    onClick={(e) => e.stopPropagation()}
                  />
                )}

                <p>{blog.metaTitle}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default BlogTabSide;